<template>
  <div v-if="order">
    <product-info :groupon="order.groupon" />
    <van-cell-group title="购买者信息">
      <div class="flex justify-between flex-row items-center p-4">
        <div class="flex items-center">
          <div class="w-12 h-12">
            <img :src="order.buyer.avatar" :alt="order.buyer.nickname" class="rounded-full">
          </div>
          <div class="pl-2">
            <div class="text-gray-600 text-base">{{ order.buyer.nickname }}</div>
            <div class="flex flex-row items-center pt-2">
              <div class="bg-lsyellow-200 items-center flex p-px">
                <van-icon name="location-o" color="white" />
              </div>
              <div class="text-xs pl-1">
                {{ order.buyer.address }}
                <span class="text-ls-500 pl-1">{{ order.buyer.distance }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <van-icon name="arrow" />
        </div>
      </div>
    </van-cell-group>

    <van-cell-group title="订单信息">
      <van-cell :title="'订单号：' + order.trade_no"></van-cell>
      <van-cell :title="'下单时间：' + order.created_at"></van-cell>
      <van-cell :title="'下单手机：' + order.buyer.mobile"></van-cell>
      <van-cell :title="'联系人：' + order.buyer.nickname"></van-cell>
      <van-cell :title="'数量： ' + order.qty"></van-cell>
      <van-cell>
        总价：<span class="text-ls-800 font-bold">￥{{ order.amount }}</span>
      </van-cell>
    </van-cell-group>
  </div>
</template>
<script>
import ProductInfo from '@/components/ProductInfo'
export default {
  components: {
    ProductInfo
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    loading () {
      return this.$store.state.loading
    }
  },
  data () {
    return {
      order: ''
    }
  },
  created () {
    this.fetch()
    this.$toast.loading({
      duration: 0
    })
  },
  methods: {
    fetch () {
      this.$http.get(this.$api.affiorders + '/' + this.id).then(res => {
        this.$toast.clear()
        let { status, data } = res
        if (status) {
          return this.$h.handleError(res)
        }
        this.order = data
      })
    }
  } // end of methods
}
</script>
